<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btn btn-outline-success" type="button" (click)="onAdd()" title="Nueva">
            <i class="fa fa-file-o"></i> Nueva
        </button>
        <button *ngIf="!visibilitySpinner" type="button" class="btn btn-outline-success" [disabled]="!exportIsAvailable()" (click)="onExportExcel()" title="Exportar">
            <i class="fa fa-file-excel-o"></i> Exportar
        </button>
        <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
    </form>
</nav>

<div class="container-fluid container-list">
    <app-permisosaccionescam-filter (search)="onSearch($event)" (clear)="onReset()" [listAcciones]="listAcciones" [listPerfiles]="listPerfiles" [listEstadosCam]="listEstadosCam" [listTiposCam]="listTiposCam" [lastFilter]="payload"></app-permisosaccionescam-filter>
    <app-permisosaccionescam-list *ngIf="searching" [result]="result" (search)="onSearchLazy($event)" (delete)="onDelete($event)" [lastFilter]="payload"></app-permisosaccionescam-list>
</div>
